import * as React from 'react';
import { DefaultLayout } from '../../../components/DefaultLayout';
import { Seo } from "../../../components/Seo";

import { YandexMetrika } from '../../../components/YandexMetrika';
import { MailRu } from '../../../components/MailRu';
import { TikTok } from '../../../components/TikTok';
import { VKPixel } from '../../../components/VKPixel';
import { AdvCake } from '../../../components/AdvCake';

import { FooterFull } from "../../../components/FooterFull";
import { GetCourseWidget } from "../../../components/GetCourseWidget";

import {
  Screen1,
  Points,
  Info,
  Vid,
  Author,
  What,
  Revs,
  Cost
} from "../../../components/LandingTemplates/1000_slov_za_nedelyu";

const TITLE = 'Выучить 1000 английских слов за неделю | Онлайн-курс запоминания иностранных слов';
const DESCRIPTION = 'Онлайн-курс «Запоминание 1000 иностранных слов за неделю» для изучения английского и других языков. Авторская методика с теорией и практикой';
export const Head = () => (
  <Seo title={TITLE} description={DESCRIPTION}>
    <title>{TITLE}</title>
  </Seo>
);
const Page = (
  { widget=(<GetCourseWidget hash={'d904f24dced4e701eb5ad8020ea038b64fc92161'} id={'343733'} />) }
) => (
  <DefaultLayout>
    <YandexMetrika />
    <MailRu />
    <TikTok />
    <VKPixel />
    <AdvCake />

    <main style={{ fontFamily: `"Roboto Slab", sans-serif`, fontSize: "18px", lineHeight: "1.25", color: "#4a4a4a" }}>
      <Screen1/>
      <Points/>
      <Info/>
      <Vid/>
      <Author/>
      <What/>
      <Revs/>
      <Cost widget={widget}/>
    </main>

    <FooterFull/>
  </DefaultLayout>
);
export default Page;
